module.exports = __webpack_public_path__ + "static/media/facebook.f55f00fd.svg";